<div class="row">
  <div class="tab-wrapper col-12">
    <div class="d-flex mt-8 mb-16 checkbox-wrapper">
      <app-checkbox
        id="canAccessModule"
        [isChecked]="hasAccessToModule() || isInPrimaryRole"
        [disabled]="isInPrimaryRole"
        (checked)="selectSusUserRole($event)"
      ></app-checkbox>
      <span>{{
        T.settings.employees_departments_org.manage_employee.can_access_sustainability_module | translate
      }}</span>
    </div>
  </div>
</div>
